import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "./config";

export const MembershipSubmitApi = createAsyncThunk(
  "MembershipSlice/MembershipSubmitApi",
  async (formData) => {
    try {
      const { data: response } = await axios.post(
        baseUrl + "membershipReqSubmit",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === "success") {
        return { data: response.data, message: response.message };
      } else {
        return Promise.reject(response);
      }
    } catch (error) {
      console.error("Membership API Error", error);
      throw error;
    }
  }
);

export const GetCompanyListApi = createAsyncThunk(
  "MembershipSlice/GetCompanyListApi",
  async () => {
    try {
      // Get token from localStorage
      const token = localStorage.getItem('memberToken');
      
      const { data: response } = await axios.get(
        baseUrl + "member/company-list",
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": token ? `Bearer ${token}` : "",
          },
        }
      );

      if (response.success) {
        return { data: response.data, message: response.message };
      } else {
        return Promise.reject(response);
      }
    } catch (error) {
      console.error("Company List API Error", error);
      throw error;
    }
  }
);

export const ExternalLoginApi = createAsyncThunk(
  "MembershipSlice/ExternalLoginApi",
  async (credentials, { rejectWithValue }) => {
    try {
      const { data: response } = await axios.post(
        baseUrl + "member/login",
        {
          ...credentials,
          isExternalLogin: true
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.success) {
        return { 
          token: response.token, 
          data: response.data,
          profileUrl: response.profileUrl,
          message: response.message 
        };
      } else {
        return rejectWithValue(response.message || "External login failed");
      }
    } catch (error) {
      console.error("External Login API Error", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "External login failed"
      );
    }
  }
);
